import './index.css'

const TabItem = props => {
  const {tabDetails, onTabChange, isActive} = props
  const {displayText, tabId} = tabDetails

  const onTabClick = () => {
    onTabChange(tabId)
  }

  const activeTabBtnClassName = isActive ? 'active-tab-btn' : ''

  return (
    <li className="tab-item-container ">
      <button
        onClick={onTabClick}
        type="button"
        className={`tab-btn ${activeTabBtnClassName}`}
      >
        {displayText}
      </button>
    </li>
  )
}

export default TabItem
